/**
 * Javascript for InjectorMain
 *
 **/

import InjectorAds from "./injector-ads";
import InjectorBanners from "./injector-banners";
import InjectorNewsletterSignup from "./injector-newsletter-signup";
import InjectorVideos from "./injector-videos";
import InjectorRightrail from "./injector-rightrail";
import InjectorTouts from "./injector-touts";
import InjectorCommerce from "./injector-commerce";
import InjectorCustom from "./injector-custom";
import InjectorPromo from "./injector-promo";
import InjectorTopnav from "./injector-topnav";
import InjectorExpandedmenu from "./injector-expandedmenu";
import InjectorFooter from "./injector-footer";

const injectorAds = new InjectorAds();
const injectorBanners = new InjectorBanners();
const injectorSignup = new InjectorNewsletterSignup();
const injectorVideos = new InjectorVideos();
const injectorRightrail = new InjectorRightrail();
const injectorTouts = new InjectorTouts();
const injectorCommerce = new InjectorCommerce();
const injectorCustom = new InjectorCustom();
const injectorPromo = new InjectorPromo();
const injectorTopnav = new InjectorTopnav();
const injectorExpandedmenu = new InjectorExpandedmenu();
const injectorFooter = new InjectorFooter();

function InjectorMain() {
  this.init = function () {
    injectorRightrail.init(); // Run first.
    injectorAds.init();
    this.getWidgets();
    $(window).on("injector:scroll_update", this, this.getWidgets);
    $(window).on("injector:inject_widgets", this, this.injectWidgets);
  };

  this.injectWidgets = (_, $article, priorities) => {
    const subscribeDisplayed = sessionStorage.getItem(
      "ess_nl_inline_displayed"
    );

    let rulesUsed = [];
    let rightrail = null;
    let topnav = null;
    let expandedmenu = null;
    let footer = null;
    for (const p in priorities) {
      if ("rightrail" === p) {
        rightrail = priorities[p];
      } else if ("topnav" === p) {
        topnav = priorities[p];
      } else if ("expandedmenu" === p) {
        expandedmenu = priorities[p];
      } else if ("footer" === p) {
        footer = priorities[p];
      } else if (
        Object.hasOwn(priorities, p) &&
        /^0$|^[1-9]\d*$/.test(p) &&
        p <= 4294967294
      ) {
        const priority = priorities[p];
        // Try/Catch to prevent widget injection errors from breaking the rightrail.
        try {
          for (const name in priority) {
            let widgets = priority[name];
            let randSum = 100;

            for (const w in widgets) {
              if (
                Object.hasOwn(widgets, w) &&
                /^0$|^[1-9]\d*$/.test(w) &&
                w <= 4294967294
              ) {
                const widget = widgets[w];

                if (
                  typeof widget === "object" &&
                  !Array.isArray(widget) &&
                  widget !== null
                ) {
                  let rule = widget.rule;
                  let rand = Math.floor(Math.random() * randSum);
                  randSum -= rand;

                  // Banner frequency is handled in the backend.
                  if ("banners" === name || rand < widget.frequency) {
                    // Allow to disable some injections.
                    if (
                      typeof pubstack.allowedInjections !== "undefined" &&
                      !pubstack.allowedInjections.includes(name)
                    ) {
                      continue;
                    }
                    switch (name) {
                      case "ads":
                        if (!rulesUsed.includes(rule) || 1) {
                          // Only one rule for ads
                          // widget contains mobile, desktop and between_article ads
                          injectorAds.betweenArticle($article, widget);
                          injectorAds.everyThird($article, widget);
                          $(window).trigger("ad:scroll_update");
                        }
                        break;
                      case "banners":
                        if (!rulesUsed.includes(rule) || 1) {
                          // Only one rule for banners
                          injectorBanners.middleParagraph(
                            $article,
                            widget.html
                          );
                        }
                        break;
                      case "videos":
                        // Allows for backup to place video at end
                        if (rulesUsed.includes(rule) && rule === "middle") {
                          rule = "end";
                        }
                        if (
                          !rulesUsed.includes(rule) &&
                          undefined !== widget.html
                        ) {
                          if (rule === "middle") {
                            injectorVideos.middleParagraph(
                              $article,
                              widget.html
                            );
                          } else {
                            injectorVideos.endParagraph($article, widget.html);
                          }
                          randSum = 0; // Only one video per article
                        }
                        break;
                      case "newsletter":
                        if (!rulesUsed.includes(rule) || 1) {
                          // Only one rule for newsletter subscribe
                          if (!subscribeDisplayed && widget !== false) {
                            injectorSignup.fifthParagraph(
                              $article,
                              widget.html
                            );
                          } else {
                            rule = null;
                          }
                        }
                        break;
                      case "touts":
                        if (!rulesUsed.includes(rule) || 1) {
                          // Only one rule for touts
                          injectorTouts.lastThirdParagraph(
                            $article,
                            widget.html
                          );
                        }
                        break;
                      case "commerce":
                        // Don't inject commerce widget in commerce articles
                        if ($article.attr("class").indexOf("commerce") === -1) {
                          if (!rulesUsed.includes(rule)) {
                            // Only one rule for commerce
                            injectorCommerce.lastThirdParagraph(
                              $article,
                              widget.html
                            );
                          }
                        }
                        break;
                      case "custom":
                        if (!rulesUsed.includes(rule)) {
                          injectorCustom.middleParagraph($article, widget.html);
                        }
                        break;
                      case "promo":
                        injectorPromo.inject(
                          rule,
                          widget.rule_num,
                          $article,
                          widget.html
                        );
                        break;
                    }

                    // Allows multiple at end of content
                    if (rule !== "end") {
                      rulesUsed.push(rule);
                    }
                  }
                }
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
    // Inject rightrail after all other content injection so that float right will not look bad.
    if (
      !(
        typeof pubstack.allowedInjections !== "undefined" &&
        !pubstack.allowedInjections.includes("rightrail")
      ) &&
      rightrail
    ) {
      injectorRightrail.inject($article, rightrail);
      $(window).trigger("ad:scroll_update");
    }
    try {
      injectorTopnav.inject(topnav);
    } catch (e) {
      console.error("Injector: topnav failed:", e);
    }
    try {
      injectorExpandedmenu.inject(expandedmenu);
    } catch (e) {
      console.error("Injector: expandedmenu failed:", e);
    }
    try {
      injectorFooter.inject(footer);
    } catch (e) {
      console.error("Injector: footer failed:", e);
    }

    $(window).trigger("injector:inject_widgets_injected", [$article]);
  };
  this.getWidgets = (event = null, $article = null) => {
    let isFirst = true;
    if (null === $article) {
      isFirst = false;
      // First article. Otherwise, iscroll will send which article.
      $article = $("#main article").first();
    }

    let post_id = $article.data("id");
    let data = {
      isAjax: isFirst,
      articlesLoaded: $("#main .article").length,
    };

    if (post_id === undefined) {
      post_id = pubstack.post_id;
      if (post_id === undefined || post_id === "") {
        post_id = 1366296; // Just use the Homepage post_id for default injection data.
      }
    }
    let sitetheme = JSON.parse(ps_ad_object[0].page_targeting).sitetheme;
    let appview = $("body").hasClass("appview1") ? "&appview1=1" : "";
    appview += $("body").hasClass("appview2") ? "&appview2=1" : "";

    fetch(
      pubstack.restUrl +
        "pubstack/v1/injector-widgets/" +
        post_id +
        "?isAjax=" +
        isFirst +
        "&articlesLoaded=" +
        $("#main .article").length +
        "&ps_theme=" +
        sitetheme +
        appview,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        $(window).trigger("injector:inject_widgets", [$article, response]);
      })
      .catch((error) => {
        console.error("Could not load injector widgets.: ", error);
      });
  };
}

export default InjectorMain;
